import { defineComponent, nextTick } from 'vue';
import { WOW } from 'wowjs';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { getQueryParam } from '@/utils';
// import zhTw from 'element-plus/es/locale/lang/zh-tw'
// import en from 'element-plus/es/locale/lang/en'
import userHooks from '@/hooks/userHooks';
export default defineComponent({
  name: 'App',
  data() {
    return {
      locale: zhCn
    };
  },
  components: {},
  setup(props, context) {
    const {
      getMacId
    } = userHooks();
    return {
      getMacId
    };
  },
  created() {
    this.setToken();
    this.getMacId();
    // window.addEventListener('message', this.handleDataFromIfream, true)
  },

  mounted() {
    nextTick(() => {
      new WOW({
        live: false
      }).init();
    });
  },
  beforeUnmount() {
    // window.removeEventListener('message', this.handleDataFromIfream, true)
  },
  methods: {
    setToken() {
      const wwToken = getQueryParam('wwToken');
      if (wwToken) {
        this.$store.commit('userInfo/setwwToken', getQueryParam('wwToken'));
        this.$store.commit('userInfo/setIfreamMode', true);
      }
    },
    handleDataFromIfream(e) {
      console.log(e, 111);
      // if (e.data.type == 'ifreamMode') {
      //   this.$store.commit('userInfo/setwwToken', e.data.data.app.token)
      //   this.$store.commit('userInfo/setIfreamMode', true)
      //   this.$store.commit('userInfo/setIfreamData', {
      //     ifreamData: e.data.data
      //   })
      // }
    }
  }
});